<template>
    <div id="login">
        <div class="container">
            <h1>Content Mangment Gateway</h1>
            <div class="form">
                <input v-model="email" type="email" placeholder="Email">
                <span class="errorTxt" v-if="errors.email.length>1">{{ errors.email}}</span>
                
                <input v-model="password" type="password" placeholder="Password">
                <span class="errorTxt" v-if="errors.password.length>1">{{ errors.password }}</span>
                
                <button class="square" @click="sendLogin">Login</button>
                <span class="errorTxt" v-if="err.length>1">{{ err }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/apis';

    export default {
        data() {
            return {
                email: '', //"content@chery.com.ly",
                password: '', //"ljj}wB4zoKQl3ahhfff",
                err: "",
                errors: {
                    email: "",
                    password: "",
                },
            }
        },
        methods: {
            validateForm() {
                // Reset errors first
                this.errors.email = "";
                this.errors.password = "";

                let isValid = true;

                // ---------- EMAIL ----------
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

                if (!this.email.trim()) {
                    this.errors.email = "Email is required";
                    isValid = false;
                } else if (this.email.length < 6) {
                    this.errors.email = "Email must be at least 6 characters";
                    isValid = false;
                } else if (this.email.length > 255) {
                    this.errors.email = "Email cannot exceed 255 characters";
                    isValid = false;
                } else if (!emailRegex.test(this.email)) {
                    this.errors.email = "Invalid email format";
                    isValid = false;
                }

                // ---------- PASSWORD ----------
                const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;

                if (!this.password) {
                    this.errors.password = "Password is required";
                    isValid = false;
                } else if (this.password.length < 8) {
                    this.errors.password = "Password must be at least 8 characters";
                    isValid = false;
                } else if (this.password.length > 255) {
                    this.errors.password = "Password cannot exceed 255 characters";
                    isValid = false;
                } else if (!passwordRegex.test(this.password)) {
                    this.errors.password = "Password must contain at least one letter and one number";
                    isValid = false;
                }

                return isValid;

            },
            sendLogin() {
                if (!this.validateForm()) {return;}
                
                this.err = "";
                api.post("/login", {
                    email: this.email,
                    password: this.password
                }, {headers: {
                    Authorization: `Bearer ${this.token}` // <-- your token here
                    }


                })
                .then(res => {
                    this.$store.state.token = res.data.token;
                    this.$router.push({name: 'newPost'})
                })
                .catch(err => {
                    this.err = err.response.data;
                    
                })
            }
        }
    }
</script>